import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { searchPdfs } from '../Services/api';

const SearchModel = ({ Show, Hide, size, onResults, onClose }) => {
    const [term, setTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [err, setErr] = useState("");

    const handleSubmit = async () => {
        if (!term.trim()) {
            setErr('Please enter a PDF name.');
            return;
        }
        setErr("");
        setLoading(true);
        try {
            const list = await searchPdfs(term.trim());
            onResults?.(Array.isArray(list) ? list : []);
        } catch (e) {
            setErr(e?.message || 'Search failed');
            onResults?.([]);

        } finally {
            setLoading(false);
        }
    }

    const handleHide = () => {
        onClose?.();
        Hide?.();
        setTerm('');
        setErr('');
        setLoading(false);
    }
    return (
        <>
            <div>
                <Modal
                    show={Show}
                    onHide={handleHide}
                    size={size}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header className="-flex justify-content-between align-items-center modal_closeButton">
                        <Modal.Title>Search Collections</Modal.Title>
                        <div
                            className="close_modal text-danger fw-bold"
                            onClick={handleHide}
                            title="Close"
                            style={{ cursor: "pointer" }}
                        >
                            X
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label className='fs-15 fw-bold'>Enter Your Pdf Name</Form.Label> <span className='text-danger fw-bold fs-13'>*</span>
                                <Form.Control
                                    type="text"
                                    className='chatBox_inputBox p-2'
                                    value={term}
                                    onChange={(e) => setTerm(e.target.value)}
                                    onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
                                />
                            </Form.Group>
                            {err && <div className="text-danger fw-bold mb-2">{err}</div>}
                        </div>
                        <div className='text-end'>
                            <Button variant='dark' onClick={handleSubmit} disabled={loading}>
                                {loading ? 'Searching…' : 'Submit'}
                            </Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        </>
    )
}

export default SearchModel